import React from 'react'

import { Icon } from 'src/chrome'

import { flexCenter, style } from './pricingTableStyles'
import Disclaimer from '../Disclaimer/Disclaimer'

interface RoundedFooterProps {
  open: boolean
  messages?: string[]
  actionTitle: string
  shouldDisclaimerBeVisible?: boolean
  isChartAvailable?: boolean
  onClick: () => void
}

const RoundedFooter: React.FC<RoundedFooterProps> = props => {
  const {
    open,
    messages,
    actionTitle,
    shouldDisclaimerBeVisible = true,
    onClick,
    isChartAvailable = true,
  } = props
  return (
    <div
      style={{
        ...style.mobileActionBar,
        ...(messages ? { justifyContent: 'space-between' } : {}),
        ...(open ? { borderRadius: 0 } : { borderRadius: '0 0 9px 9px' }),
      }}
      onClick={onClick}
    >
      {shouldDisclaimerBeVisible && <Disclaimer messages={messages} />}
      <div
        style={flexCenter}
        css={{
          cursor: 'pointer',
          display: isChartAvailable ? 'flex' : 'none !important',
        }}
      >
        <span
          style={{
            fontSize: '1.75rem',
            fontWeight: 800,
            paddingRight: 12,
            color: 'rgba(0, 0, 0, .65)',
          }}
        >
          {actionTitle}
        </span>
        <div style={{ paddingTop: 2 }}>
          <Icon
            color={'rgba(0, 0, 0, .55)'}
            size={15}
            icon={open ? 'ARROWUP' : 'ARROWDOWN'}
          />
        </div>
      </div>
    </div>
  )
}

export default RoundedFooter
